import styled from 'styled-components';
import { colors, dimensions, typography } from '../../styles';

const inputPadding = '0px';
const inputHeight = '16px';
const inputScale = '12px';
const inputBorderWidth = '1px';
const textInputHeight = '34px';

const Label = styled.label`
  // text-transform: uppercase;  
  display: inline-block;
  font-weight: ${typography.fontWeightMedium};
  color: ${colors.textSecondary};
  font-size: ${typography.fontSizeUppercase}px;
  margin-bottom: 5px;

  margin-right: 10px;
  position: absolute;
  left: 10px;
  top: -10px;
  color: #626262;
  padding: 0px 8px 0px 8px;
  background: #ffffff;

  span {
    color: ${colors.colorCoreRed};
  }
`;

//browser default form invalid styling
const formInvalid = `
  &.form-invalid {
    border-bottom: 1px solid ${colors.colorCoreRed};
  }
`;

const FormControl = styled.div`
  margin-bottom: 30px;
  position: relative;

  label {
    margin-right: ${dimensions.unitSpacing}px;
    position: relative;
    left: 10px;
    top: -10px;
    color: #626262;
    padding: 0px 8px 0px 8px;
    background: red;
  }
`;

const Formgroup = styled.div`
  margin-bottom: 0px;
  position: relative;

  &::before {
    position: absolute;
    content: '';
    // background-color: rgb(255, 255, 255);
    left: 10px;
    // width: 60px;
    height: 21px;
    top: -10px;
  }

  label {
    margin-right: 35px;
    position: relative;
    // left: 10px;
    top: -10px;
    color: #626262;
    // padding: 0px 8px 0px 8px;
    background: #ffffff;
    margin-bottom: 2px;
    left: -2px;
  }

  p {
    font-size: 12px;
    color: ${colors.colorCoreGray};
    margin: 0;
  }

  .Select {
    // border: 0.800000011920929px solid #dae0e6;
    // border-radius: 5px;
    // background: #faf8ff;
    /* width: 450px; */
    /* height: 40px; */
    font-size: 12px;
    text-transform: none;
    color: #000;
    font-weight: 400;
    // margin-top: 10px;
  }

  // .Select-placeholder {
  //   color: #131313;
  // }
`;

const Input = styled.input`
  ${formInvalid} display: block;
  border: none;
  width: 100%;
  height: ${textInputHeight};
  padding: ${dimensions.unitSpacing}px;
  color: ${colors.textPrimary};
  border-bottom: 1px solid ${colors.colorShadowGray};
  background: none;
  transition: all 0.3s ease;
  // background: #FAF8FF;
  //   border: 0.800000011920929px solid #DAE0E6;
  //   border-radius: 5px;

  ${props => {
    if (props.round) {
      return `
        font-size: 13px;
        border: 1px solid ${colors.borderDarker};
        border-radius: 20px;
        padding: 5px 20px;
      `;
    }
  }};

  ${props => {
    if (props.disabled) {
      return `
        color: #999797;
      `;
    }
  }};

  &:hover {
    border-color: ${colors.colorLightGray};
  }

  &:focus {
    outline: none;
    border-color: ${colors.colorPrimary};
  }
`;
const FileInput = styled.input`
  ${formInvalid} display: block;
  border: none;
  width: 100%;
  height: ${textInputHeight};
  padding: ${dimensions.unitSpacing}px;
  color: ${colors.textPrimary};

  ${props => {
    if (props.round) {
      return `
        font-size: 13px;
        padding: 5px 20px;
      `;
    }
  }};
`;

const SelectWrapper = styled.div`
  ${formInvalid} overflow: hidden;
  border-bottom: 1px solid ${colors.colorShadowGray};
  width: 100%;
  height: ${textInputHeight};
  position: relative;

  &:after {
    position: absolute;
    right: 10px;
    top: 12px;
    content: '\\e827';
    font-size: 10px;
    display: inline-block;
    font-family: 'erxes';
    speak: none;
    color: ${colors.colorCoreGray};
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
  }
`;

const Select = Input.withComponent('select').extend`
  ${formInvalid}

  border: none;
  height: ${textInputHeight};
  padding: 0 ${dimensions.unitSpacing}px;
  width: calc(100% + ${dimensions.coreSpacing}px);
  -webkit-appearance: none;
`;

const TextArea = Input.withComponent('textarea').extend`
  ${formInvalid}
  transition: none;
  max-height: ${props => props.maxHeight && `${props.maxHeight}px`};
  min-height: 80px;
`;

const FormLabel = styled.label`
  position: relative;
  display: inline-block;
  font-weight: normal;

  span {
    cursor: pointer;
    display: inline-block;
  }
`;

const inputStyle = styled.input`
  ${formInvalid} border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;

  &:focus {
    + span {
      &::before {
        box-shadow: 0 0 0 2px rgba(#333, 0.4) !important;
      }
    }
  }

  &:hover {
    + span {
      &::before {
        border-color: ${colors.colorLightGray};
      }
    }
  }

  &:active {
    + span {
      &::before {
        transition-duration: 0;
      }
    }
  }

  + span {
    position: relative;
    padding: ${inputPadding};
    user-select: none;

    &:before {
      background-color: ${colors.colorWhite};
      border: ${inputBorderWidth} solid ${colors.colorShadowGray};
      box-sizing: content-box;
      content: '';
      color: ${colors.colorWhite};
      margin-right: calc(${inputHeight} * 0.25);
      top: 51%;
      left: 0;
      width: ${inputHeight};
      height: ${inputHeight};
      display: inline-block;
      vertical-align: text-top;
    }

    &:after {
      box-sizing: content-box;
      content: '';
      background-color: ${colors.colorWhite};
      position: absolute;
      top: 55%;
      left: calc(${inputPadding} + ${inputBorderWidth} + ${inputScale} / 2);
      width: calc(${inputHeight} - ${inputScale});
      height: calc(${inputHeight} - ${inputScale});
      margin-top: calc((${inputHeight} - ${inputScale}) / -2);
      transform: scale(0);
      transform-origin: 51%;
      transition: transform 200ms ease-out;
    }
  }

  + span:last-child:before {
    margin-right: 0px;
  }
`;

const Radio = inputStyle.extend`
  + span {

    &::before,
    &::after {
      border-radius: 50%;
    }
  }

  &:checked {

    &:active,
    &:focus {

      + span {

        &::before {
          animation: none;
          filter: none;
          transition: none;
        }
      }
    }

    + span {

      &:before {
        animation: none;
        background-color: ${colors.colorPrimary};
        border-color: transparent;
      }

      &:after {
        transform: scale(1);
      }
    }
  }
`;

const Checkbox = inputStyle.extend`
  + span {
    &:after {
      background-color: transparent;
      top: 51%;
      left: calc(1px + ${inputHeight}/5);
      width: calc(${inputHeight}/2);
      height: calc(${inputHeight}/5);
      margin-top: calc(${inputHeight} / -2 / 2 * 0.8);
      border-style: solid;
      border-color: ${colors.colorWhite};
      border-width: 0 0 2px 2px;
      border-radius: 0;
      border-image: none;
      transform: rotate(-45deg) scale(0);
      transition: none;
    }
  }

  &:checked + span {

    &:before {
      animation: none;
      background-color: ${colors.colorPrimary};
      border-color: transparent;
    }

    &:after {
      content: '';
      transform: rotate(-45deg) scale(1);
      transition: transform 200ms ease-out;
    }
  }
`;

const SoundGroup = styled.div`
  // height: 211px;
  padding: 70px 0px 70px 0px;
  width: 100%;
  margin: 15px 0 auto;
  position: relative;
  text-align: center;
  // line-height: 195px;
  border: 1px dashed #dae0e6;
  display: inline-block;
  transition: transform 0.3s;
  background: #faf8ff;
  letter-spacing: 0.23px;
  color: #5b5b5b;
  border-radius: 14px;
  img {
    display: block;
    width: 40px !important;
    height: 40px !important;
    // margin: 50px auto -57px auto;
    border-radius: 0px;
    margin: auto;
  }
  input[type='file'] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
    cursor: pointer;
  }
`;

const UserProfile = styled.div`
  text-align: center;
  input[type='file'] {
    position: absolute;
    height: 28%;
    width: 100%;
    opacity: 0;
    top: 50px;
    left: 0;
    cursor: pointer;
  }
  img {
    display: block;
    // width: 40px !important;
    // height: 40px !important;
    // margin: 50px auto -57px auto;
    border-radius: 50px;
    margin: auto;
  }
`;

export {
  Input,
  SelectWrapper,
  Select,
  TextArea,
  Radio,
  Checkbox,
  FormLabel,
  FormControl,
  Label,
  Formgroup,
  FileInput,
  SoundGroup,
  UserProfile
};



// WEBPACK FOOTER //
// src/modules/common/components/form/styles.js